import {Injectable} from '@angular/core';
import {Headers, Http} from "@angular/http";
import {ImageSize} from "../../models/data.model";
import {Loading, LoadingController} from "ionic-angular";
import * as base64Img from "../../../node_modules/base64-img";

@Injectable()
export class RestProvider {

  apiUrl: string = "https://appbase.escalaguil.fr/api/"; //"https://appbase.escalaguil.fr/api/";
  loading: Loading;

  constructor(public http: Http, public loadingCtrl: LoadingController) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
  }

  public static getMarkerOrange(): string {
    return "http://appbase.escalaguil.fr/markers/marker-hover.png";
  }

  public getAll<T>(url: RestRoutes, isLoader: boolean): Promise<T[]> {
    if (isLoader) this.presentLoader();
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl + "sites/")
        .subscribe(
          result => {
            if (isLoader) this.dismissLoader();
            resolve(JSON.parse(result.text()) as T[]);
          },
          error => {
            if (isLoader) this.dismissLoader();
            reject(error)
          }
        );
    });
  }

  public get<T>(id: any, url: string, isLoader: boolean): Promise<T> {
    if (isLoader) this.presentLoader();
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl + url + id)
        .subscribe(
          result => {
            if (isLoader) this.dismissLoader();
            resolve(JSON.parse(result.text()) as T);
          },
          error => {
            if (isLoader) this.dismissLoader();
            reject(error);
          }
        );
    });
  }

  private presentLoader(): void {
    this.loading = this.loadingCtrl.create({
      spinner: 'crescent',
    });
    this.loading.present().catch();
  }

  private dismissLoader(): void {
    this.loading.dismiss().catch();
  }

  public static getPhotoSize(photoUrl: string): Promise<ImageSize> {
    return new Promise<ImageSize>((resolve) => {
      let img = new Image();
      img.src = photoUrl;
      img.onload = function () {
        resolve({
          // @ts-ignore
          width: this.width,
          // @ts-ignore
          height: this.height
        })
      }
    });
  }

  public static getPhoto(photo): Promise<any> {
    var proxy = "https://cors-anywhere.herokuapp.com/";
    return new Promise<any>((resolve, reject) => {
      base64Img.requestBase64(proxy + "http://appbase.escalaguil.fr/photos/"  + photo, function(err, res, body) {
        if (err) reject(err);
        else resolve(body);
      });
    });
  }
}

export enum RestRoutes {
  sites = 'sites/',
  routes = 'routes/',
  photos = 'photos/',
  content = 'content/',
  lastUpdate = 'lastUpdate'
}



// WEBPACK FOOTER //
// ./src/providers/rest/rest.ts